import { TRIAL_EARLY_ADOPTERS_PLAN_CODE } from '../config/subscription.config';
import type { SubscriptionMe } from '../model/subscription.types';

export function isReferralEligible(subscription: SubscriptionMe | null | undefined): boolean {
    if (!subscription) return false;
    if (subscription.isTrial) return false;
    if (subscription.planCode === TRIAL_EARLY_ADOPTERS_PLAN_CODE) return false;

    return subscription.status === 'ACTIVE' || subscription.status === 'PAST_DUE';
}
